module.exports = __webpack_public_path__ + "img/RECL.b6b75711.svg";